// import { getStorageFileUrl } from '@/services/ant-design-pro/library';
import { Button, Cascader, InputNumber, Input, message, Modal, Select, Upload } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import className from 'classnames';
import { UploadOutlined } from '@ant-design/icons';
import { useUpload } from '@/hooks';
import { getDetailByVersionId, updateMaterial } from '@/services/source';
import { EmptyShaderColor } from 'patternx-svg';
import { deepfind } from '../../element/utils';

interface Props {
  info: any;
  categoryOptions: any[];
  onClose: () => void;
  onUpdate: () => void;
  appOptions: any[];
  businessCategorys: any[];
}

// 记录xhr
let uploadXhr: XMLHttpRequest | null = null;

const EditMaterialModal: React.FC<Props> = (props: Props) => {
  const { info, categoryOptions, onClose, onUpdate, appOptions, businessCategorys } = props;

  const [details, setDetails] = useState(info);
  const [file, setFile] = useState<any>({
    thumbnailUrl: '',
  });
  const [isNameInvalid, setIsNameInvalid] = useState(false);
  const [isCategoryInvalid, setIsCategoryInvalid] = useState(false);
  const [isLongInvalid, setIsLongInvalid] = useState(false);
  const [isWidthInvalid, setIsWidthInvalid] = useState(false);
  const [isAppInvalid, setIsAppInvalid] = useState(false);
  const [isBusinessCategoryInvalid, setIsBusinessCategoryInvalid] = useState(false);

  const defaultCategoryIds = useMemo(() => {
    for (let i = 0; i < categoryOptions.length; i++) {
      const category = categoryOptions[i];
      if (details.categoryId === category.id) {
        return [category.id];
      }
      for (let j = 0; j < category.children.length; j++) {
        const subCategory = category.children[j];
        if (details.categoryId === subCategory.id) {
          return [category.id, subCategory.id];
        }
      }
    }
    return [];
  }, [details, categoryOptions]);

  // 获取层级标签
  const tagsArr = useMemo(() => {
    if (!businessCategorys.length) return;
    function getName(ele: any, labels: any[]) {
      if (ele?.pid) {
        const activeElement = deepfind(businessCategorys, 'id', ele.pid);
        if (activeElement?.id) {
          labels.unshift(activeElement.id);
        }
        getName(activeElement, labels);
      }
    }
    const mapResult: any[] = [];
    (details?.businessCategoryIds || [])?.forEach((curTag: any) => {
      const ele = deepfind(businessCategorys, 'id', curTag);
      if (ele) {
        mapResult.unshift(ele.id);
        if (ele?.pid) {
          getName(ele, mapResult);
        }
      }
    });
    return mapResult;
  }, [details.businessCategoryIds, businessCategorys]);

  const { uploadRequest } = useUpload();

  const getDetails = async () => {
    if (info.currentVersionId) {
      const res = await getDetailByVersionId(info.currentVersionId);
      if (res?.success) {
        const datas = res?.data?.details || {};
        setDetails(datas);
      }
    }
  };

  useEffect(() => {
    getDetails();
    return () => {
      uploadXhr = null;
    };
  }, []);

  //文件名截取后缀之前的部分
  const getFileName = (name: string) => {
    const lowerName = name?.toLowerCase();
    const isIntercept =
      lowerName.endsWith('.png') || lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg');
    if (isIntercept) {
      return name?.slice(0, name?.lastIndexOf('.'));
    }
    return name;
  };

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const checkFileIsValid = (file: any) => {
    const fileName = file?.name?.toLowerCase();
    if (!fileName.endsWith('.png') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg')) {
      return false;
    }
    return true;
  };

  const uploadFile = (files: any, callback: Function) => {
    const fileName = getFileName(files.name);
    const fileSuffix = (files?.name?.split('.')?.pop() ?? 'png')?.toLowerCase();
    uploadRequest({
      url: '/boss/api/v1/material/public/file:upload',
      fileStream: files,
      appName: 'boss',
      fileName: `${fileName}.${fileSuffix}`,
      fileSuffix: fileSuffix,
      fullPath: '/test/',
      fileSize: files?.size,
      onPreload: (xhr: XMLHttpRequest) => {
        uploadXhr = xhr;
      },
      onProgress: () => {},
      onSuccess: async (res: any) => {
        const { file, storage } = res ?? {};
        file.thumbnailUrl = await getBase64(file);
        file.fileStorageId = storage?.storageFileId;
        file.status = 'done';
        file.percent = 100;
        // file.long = 1000;
        // file.width = 1000;
        // file.appList = appOptions?.map((a) => a.value) || [];
        callback?.(file);
      },
      onError: async (err: any) => {
        const { exists, file, storage } = err ?? {};
        if (exists) {
          file.thumbnailUrl = await getBase64(file);
          file.fileStorageId = storage?.storageFileId;
          file.status = 'done';
          file.percent = 100;
          // file.long = 1000;
          // file.width = 1000;
          // file.appList = appOptions?.map((a) => a.value) || [];
          callback?.(file);
        }
      },
    });
  };

  const beforeUpload = async (file: any) => {
    uploadXhr?.abort();
    if (!checkFileIsValid(file)) {
      return Upload.LIST_IGNORE;
    }
    uploadFile(file, (f: any) => {
      setFile(f);
      setDetails((d: any) => {
        return {
          ...d,
          name: getFileName(f.name),
        };
      });
    });
    return true;
  };

  // const fileItemRender = (_originNode: any, file: any) => {
  //   return (
  //     <div className={styles.fileItemWrap}>
  //       <div className={styles.fileItem}>
  //         {!file.cmd5 ? (
  //           <IconFont className={styles.lfBtn} type="icon-fujian-xian" />
  //         ) : (
  //           <SyncOutlined spin className={styles.lfBtn} />
  //         )}
  //         <div
  //           className={`${styles.fileName} ${styles[file.status]}`}
  //           title={file.name || file.fileName}
  //         >
  //           {file.name || file.fileName}
  //         </div>
  //         <IconFont
  //           className={styles.rtBtn}
  //           type="icon-a-shanchu"
  //           onClick={() => {
  //             // handleDeleteClick(file.uid);
  //           }}
  //         />
  //       </div>
  //       <div className={styles.fileState}>
  //         {file.status === 'uploading' && (
  //           <Progress
  //             strokeColor={{
  //               '0%': '#108ee9',
  //               '100%': '#87d068',
  //             }}
  //             strokeWidth={4}
  //             percent={parseInt(file.percent)}
  //             size="small"
  //           />
  //         )}
  //         {file.status === 'error' && (
  //           <div className={styles.errorStatus}>
  //             <CloseCircleFilled style={{ color: '#ff4d4f', marginRight: 8 }} />
  //             {file.response?.message || '上传失败。发生未知错误，请重新上传'}
  //           </div>
  //         )}
  //       </div>
  //     </div>
  //   );
  // };

  const onNameChange = (e: any) => {
    const target: any = e.target;
    const value = target?.value.trim();
    setDetails((d: any) => {
      return {
        ...d,
        name: value,
      };
    });
  };
  const onCategoryChange = (values: any[]) => {
    // console.log(values);
    let id = '';
    if (!values || values.length === 0) {
      id = '';
    } else if (values.length === 1) {
      id = values[0];
    } else if (values.length === 2) {
      id = values[1];
    }
    setDetails((d: any) => {
      return {
        ...d,
        categoryId: id,
      };
    });
  };

  const onBusinessCategoryChange = (values: any[]) => {
    // console.log(values);
    let id = '';
    if (!values || values.length === 0) {
      id = '';
    } else {
      id = values[values.length - 1];
    }
    setDetails((d: any) => {
      return {
        ...d,
        businessCategoryIds: id ? [id] : [],
      };
    });
  };

  const onSave = async () => {
    // const businessCategoryLength = details?.businessCategoryIds?.length;
    // const businessCategory =
    //   businessCategoryLength > 0 ? details?.businessCategoryIds[businessCategoryLength - 1] : '';
    const material = {
      categoryId: details.categoryId,
      materialVersionId: details?.materialVersionId,
      length: details?.length,
      md5: file?.md5 || details?.md5,
      name: details.name,
      storageFileId: file.fileStorageId || details.storageFileId,
      appList: details.appList,
      width: details.width,
      businessCategoryIds: details?.businessCategoryIds || [],
    };
    if (!details.name) {
      setIsNameInvalid(true);
      message.error('未填必填字段');
      return;
    }
    if (!details.categoryId) {
      setIsCategoryInvalid(true);
      message.error('未填必填字段');
      return;
    }
    if (!details?.businessCategoryIds?.length) {
      setIsBusinessCategoryInvalid(true);
      message.error('未填必填字段');
      return;
    }
    if (!details.length && details.length !== 0) {
      setIsLongInvalid(true);
      message.error('未填必填字段');
      return;
    }
    if (!details.width && details.width !== 0) {
      setIsWidthInvalid(true);
      message.error('未填必填字段');
      return;
    }
    if (details.length < 10 || details.length > 10000) {
      message.error('尺寸范围限制10-10000');
      setIsLongInvalid(true);
      return;
    }
    if (details.width < 10 || details.width > 10000) {
      message.error('尺寸范围限制10-10000');
      setIsWidthInvalid(true);
      return;
    }
    if (!details.appList || details?.appList?.length === 0) {
      setIsAppInvalid(true);
      message.error('至少选择一个应用');
      return;
    }
    const res = await updateMaterial(material);
    if (res?.success) {
      message.success('材质更新成功');
      onUpdate();
      onClose();
    }
  };

  const onLocalLongChange = (e: any) => {
    setDetails((d: any) => {
      return {
        ...d,
        length: e,
      };
    });
  };

  const onLocalWidthChange = (e: any) => {
    setDetails((d: any) => {
      return {
        ...d,
        width: e,
      };
    });
  };

  const onLocalAppChange = (e: any) => {
    // if (e?.length === 0 || !e) {
    //   return;
    // }
    setDetails((d: any) => {
      return {
        ...d,
        appList: e || [],
      };
    });
  };

  const [imgStyle, setImgStyle] = useState<any>({ width: '100%', height: 'auto' });
  useEffect(() => {
    const imgUrl = file?.thumbnailUrl || details?.baseThumbnailUrl;
    if (imgUrl) {
      const imgEle = new Image();
      imgEle.src = imgUrl;
      imgEle.onload = function () {
        if (imgEle.width > imgEle.height) {
          setImgStyle({
            width: '100%',
            height: 'auto',
          });
        } else {
          setImgStyle({
            height: '100%',
            width: 'auto',
          });
        }
      };
    }
  }, [file?.thumbnailUrl, details?.baseThumbnailUrl]);

  return (
    <Modal
      visible={true}
      width={800}
      title={info.name}
      onCancel={onClose}
      onOk={onSave}
      okText="保存"
    >
      <div className={styles.editWrap}>
        <div className={styles.left}>
          <div className={styles.icon}>
            {file?.thumbnailUrl ||
            details?.baseThumbnailUrl ||
            details?.transferStatus === 'transfered' ? (
              <img src={file?.thumbnailUrl || details?.baseThumbnailUrl} style={imgStyle} />
            ) : (
              <EmptyShaderColor size={180} />
            )}
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle)}>文件</div>
            <div className={styles.pickContent}>
              <Upload
                accept=".png,.jpg,.jpeg"
                showUploadList={false}
                maxCount={1}
                beforeUpload={beforeUpload}
              >
                <Button icon={<UploadOutlined />}>重新上传</Button>
              </Upload>
            </div>
          </div>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle, styles.required, styles.required2)}>
              名称
            </div>
            <div className={styles.pickContent}>
              <Input
                className={className({
                  [styles.invalid]: isNameInvalid,
                })}
                maxLength={50}
                value={details.name}
                onChange={onNameChange}
                onFocus={() => {
                  setIsNameInvalid(false);
                }}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle, styles.required, styles.required2)}>
              分类
            </div>
            <div className={styles.pickContent}>
              <Cascader
                className={className({
                  [styles.invalid]: isBusinessCategoryInvalid,
                })}
                // changeOnSelect
                expandTrigger="hover"
                value={tagsArr}
                options={businessCategorys}
                style={{ flex: 1 }}
                onChange={onBusinessCategoryChange}
                onFocus={() => setIsBusinessCategoryInvalid(false)}
                placeholder="选择分类"
                placement="bottomLeft"
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle, styles.required)}>物理属性</div>
            <div className={styles.pickContent}>
              <Cascader
                className={className({
                  [styles.invalid]: isCategoryInvalid,
                })}
                // changeOnSelect
                expandTrigger="hover"
                value={defaultCategoryIds}
                options={categoryOptions}
                style={{ flex: 1 }}
                onChange={onCategoryChange}
                onFocus={() => setIsCategoryInvalid(false)}
                placeholder="选择物理属性"
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle, styles.required, styles.required1)}>
              <span style={{ visibility: 'hidden' }}>长</span>长
            </div>
            <div className={className(styles.pickContent)}>
              <InputNumber
                className={className({
                  [styles.invalid]: isLongInvalid,
                })}
                value={details.length}
                // min={10}
                // max={10000}
                onChange={onLocalLongChange}
                onFocus={() => {
                  setIsLongInvalid(false);
                }}
                addonAfter={<span className={styles.inputAfter}>mm</span>}
              />
            </div>
            <div className={className(styles.pickTitle, styles.required, styles.required1)}>
              <span style={{ visibility: 'hidden' }}>宽</span>宽
            </div>
            <div className={className(styles.pickContent)}>
              <InputNumber
                className={className({
                  [styles.invalid]: isWidthInvalid,
                })}
                defaultValue={details.width}
                // min={10}
                // max={10000}
                onChange={onLocalWidthChange}
                onFocus={() => {
                  setIsWidthInvalid(false);
                }}
                addonAfter={<span className={styles.inputAfter}>mm</span>}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <div className={className(styles.pickTitle, styles.required, styles.required2)}>
              应用
            </div>
            <div className={className(styles.pickContent, styles.pickPropery)}>
              <Select
                className={className({
                  [styles.invalid]: isAppInvalid,
                })}
                mode="multiple"
                placeholder="请选择应用"
                value={details?.appList || []}
                onChange={onLocalAppChange}
                style={{ width: '100%' }}
                options={appOptions}
                showArrow
                onFocus={() => setIsAppInvalid(false)}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditMaterialModal;
